export default __webpack_public_path__ + "static/media/nfkd.9a30f0a8.png";